import apiClient from './api';
import {
  GetAllCitiesResponse,
  CreateCityRequest,
  CreateCityResponse,
  UpdateCityRequest,
  UpdateCityResponse,
  DeleteCityResponse,
  ReorderCitiesRequest,
  ReorderCitiesResponse,
} from '../types/city.types';

export const cityService = {
  /**
   * Get all cities
   * The interceptor prefixes the request with /admins -> GET /admins/cities
   */
  getAllCities: async (): Promise<GetAllCitiesResponse> => {
    const response = await apiClient.get<GetAllCitiesResponse>('/cities');
    return response.data;
  },

  /**
   * Create a new city
   */
  createCity: async (data: CreateCityRequest): Promise<CreateCityResponse> => {
    const response = await apiClient.post<CreateCityResponse>('/cities', data);
    return response.data;
  },

  /**
   * Update a city (rename and/or set as default)
   */
  updateCity: async (cityId: string, data: UpdateCityRequest): Promise<UpdateCityResponse> => {
    const response = await apiClient.patch<UpdateCityResponse>(`/cities/${cityId}`, data);
    return response.data;
  },

  /**
   * Delete a city
   */
  deleteCity: async (cityId: string): Promise<DeleteCityResponse> => {
    const response = await apiClient.delete<DeleteCityResponse>(`/cities/${cityId}`);
    return response.data;
  },

  /**
   * Reorder cities by displayOrder
   * The interceptor prefixes the request with /admins -> PATCH /admins/cities/reorder
   */
  reorderCities: async (data: ReorderCitiesRequest): Promise<ReorderCitiesResponse> => {
    const response = await apiClient.patch<ReorderCitiesResponse>('/cities/reorder', data);
    return response.data;
  },
};
